import { Navigate, Outlet } from "react-router-dom";
import { getMeSession } from "@/lib/auth/storage";

export function MeAuthGuard() {
  if (!getMeSession()) {
    return <Navigate to="/me/login" replace />;
  }
  return <Outlet />;
}
